module.exports = __webpack_public_path__ + "img/gr.90595896.svg";